/* eslint-disable id-length */

/* eslint-disable no-plusplus, no-mixed-operators, no-param-reassign */
var easings = {
  linear: function linear(i) {
    return i;
  },
  easeInQuad: function easeInQuad(i) {
    return i * i;
  },
  easeOutQuad: function easeOutQuad(i) {
    return i * (2 - i);
  },
  easeInOutQuad: function easeInOutQuad(i) {
    return i < 0.5 ? 2 * i * i : -1 + (4 - 2 * i) * i;
  },
  easeInCubic: function easeInCubic(i) {
    return i * i * i;
  },
  easeOutCubic: function easeOutCubic(i) {
    return --i * i * i + 1;
  },
  easeInOutCubic: function easeInOutCubic(i) {
    return i < 0.5 ? 4 * i * i * i : (i - 1) * (2 * i - 2) * (2 * i - 2) + 1;
  },
  easeInQuart: function easeInQuart(i) {
    return i * i * i * i;
  },
  easeOutQuart: function easeOutQuart(i) {
    return 1 - --i * i * i * i;
  },
  easeInOutQuart: function easeInOutQuart(i) {
    return i < 0.5 ? 8 * i * i * i * i : 1 - 8 * --i * i * i * i;
  },
  easeInQuint: function easeInQuint(i) {
    return i * i * i * i * i;
  },
  easeOutQuint: function easeOutQuint(i) {
    return 1 + --i * i * i * i * i;
  },
  easeInOutQuint: function easeInOutQuint(i) {
    return i < 0.5 ? 16 * i * i * i * i * i : 1 + 16 * --i * i * i * i * i;
  }
};

var getDocumentHeight = function getDocumentHeight() {
  return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
};

function scrollIt(destination) {
  var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 250;
  var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'easeInOutCubic';
  var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var start = window.pageYOffset;
  var startTime = 'now' in window.performance ? window.performance.now() : new Date().getTime();
  var documentHeight = getDocumentHeight();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  var destinationOffset = (typeof destination === 'number' ? destination : destination.offsetTop) - padding;
  var maxPossibleOffset = Math.max(0, documentHeight - windowHeight);
  var scrollDestination = Math.max(0, Math.round(destinationOffset > maxPossibleOffset ? maxPossibleOffset : destinationOffset));

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, scrollDestination);
    callback();
    return;
  }

  function scroll() {
    var now = 'now' in window.performance ? window.performance.now() : new Date().getTime();
    var time = Math.min(1, (now - startTime) / duration);
    var timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil(timeFunction * (scrollDestination - start) + start));
    var currentDocumentHeight = getDocumentHeight();
    var currentMaxPossibleOffset = Math.max(0, currentDocumentHeight - windowHeight);
    var offsetOutOfBounds = scrollDestination > currentMaxPossibleOffset;
    var reachedOffset = Math.abs(scrollDestination - window.pageYOffset) <= 1;

    if (offsetOutOfBounds || reachedOffset) {
      callback();
      return;
    }

    window.requestAnimationFrame(scroll);
  }

  scroll();
}

module.exports = {
  scrollHere: scrollIt
};
module.exports.scrollHere = scrollIt;
module.exports.easings = easings;